export default __webpack_public_path__ + "static/media/motivation.739b1d0e.jpg";